import { ColumnDef } from "@tanstack/react-table";
import { DatabaseSchema } from "./schema";

export const columns = [
  {
    accessorKey: "SCHEMA",
    header: "Schema",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "TABLE_NAME",
    header: "Table Name",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "COLUMN_ID",
    header: "Column ID",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "COLUMN_NAME",
    header: "Column Name",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "DATA_TYPE",
    header: "Data Type",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "NOT_NULL",
    header: "Not Null",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "PRIMARY_KEY",
    header: "Primary Key",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "COMMENTS",
    header: "Comments",
    cell: (info) => info.getValue(),
  },
];
